"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _job = require("_a/admin/job/job");
var _message = require("_l/message");
var _vuex = require("vuex");
var _jobLogManage = _interopRequireDefault(require("@/views/admin/job/job-log-manage"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'job-manage',
  components: {
    JobLogManage: _jobLogManage.default,
    TablePage: _tablePage.default
  },
  data: function data() {
    var validateCronCheck = function validateCronCheck(rule, value, callback) {
      if (value !== '') {
        (0, _job.checkCronExpressionIsValid)(value).then(function (res) {
          if (!res.data) {
            callback(new Error('cron表达式输入不对，请重新输入'));
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    };
    return {
      columns: [{
        label: '任务名称',
        prop: 'jobName'
      }, {
        label: '任务组名',
        slot: 'jobGroup'
      }, {
        label: '调用目标字符串',
        prop: 'invokeTarget'
      }, {
        label: 'cron表达式',
        prop: 'cronExpression'
      }, {
        label: '状态',
        slot: 'jobStatus'
      }, {
        label: '操作',
        slot: 'action'
      }],
      queryParams: {},
      dialogShow: false,
      dialogTaskLogShow: false,
      delBtnDisabled: true,
      dialogTitle: '添加任务',
      form: {},
      rules: {
        jobName: [this.$ruler('任务名称')],
        jobGroup: [this.$ruler('任务组名')],
        invokeTarget: [this.$ruler('调用目标字符串')],
        cronExpression: [this.$ruler('cron表达式'), {
          validator: validateCronCheck,
          trigger: 'blur'
        }]
      },
      misfirePolicyOptionList: [],
      concurrentOptionList: [],
      jobStatusOptionList: [],
      jobGroupStatusOptionList: [],
      cunRow: null
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 添加弹出框
     */
    addJob: function addJob() {
      this.form = {
        misfirePolicy: '3',
        concurrent: '1',
        jobStatus: '0'
      };
      this.dialogTitle = '添加任务';
      this.dialogShow = true;
    },
    /**
     * 修改弹出框
     * @param row
     */
    update: function update(row) {
      this.form = _objectSpread({}, row);
      this.dialogTitle = '修改任务';
      this.dialogShow = true;
    },
    /**
     * 点击每一行的checkbox
     */
    selectVal: function selectVal(ids) {
      this.ids = ids.map(function (val) {
        return val['id'];
      });
      this.delBtnDisabled = !this.ids.length;
    },
    /**
     * 批量删除
     */
    removeBatch: function removeBatch() {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _job.deleteBatchJobById)(_this.ids).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          _this.refresh();
        });
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this2 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _job.deleteJobById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this2.refresh();
        });
      });
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this3 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this3.dialogTitle === '添加任务') {
            (0, _job.addJob)(_this3.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('add');
              } else {
                (0, _message.MessageError)('add');
              }
              _this3.cancelDialogAndRefresh();
            });
          } else {
            (0, _job.updateJob)(_this3.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('upd');
              } else {
                (0, _message.MessageError)('upd');
              }
              _this3.cancelDialogAndRefresh();
            });
          }
        }
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      // 清空表单
      this.handleReset('form');
      // 刷新表格
      this.refresh();
    },
    /**
     * 执行一次
     * @param row
     */
    runOne: function runOne(row) {
      var _this4 = this;
      this.$confirm('确认要立即执行一次任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _job.runJob)(row.id).then(function (res) {
          if (res.data) {
            _this4.$message.success('操作成功');
          } else {
            _this4.$message.error('操作失败');
          }
        });
      });
    },
    /**
     * 切换状态
     * @param row
     */
    changeStatus: function changeStatus(row) {
      var _this5 = this;
      var obj = {
        id: row.id,
        jobGroup: row.jobGroup,
        jobStatus: row.jobStatus
      };
      var typeName = row.jobStatus === '0' ? '启用' : '禁用';
      this.$confirm('确认要' + typeName + '任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _job.changeStatusJob)(obj).then(function (res) {
          if (res.data) {
            _this5.$message.success(typeName + '成功');
          } else {
            _this5.$message.error(typeName + '失败');
          }
        });
      }).catch(function () {
        row.jobStatus = !row.jobStatus;
      });
    },
    /**
     * 获取调度日志
     * @param row
     */
    taskLog: function taskLog(row) {
      this.cunRow = row;
      this.$nextTick(function () {
        this.dialogTaskLogShow = true;
      });
    }
  }),
  mounted: function mounted() {
    var _this6 = this;
    this.getDictListByType('misfire_policy_type').then(function (res) {
      _this6.misfirePolicyOptionList = res;
    });
    this.getDictListByType('concurrent_type').then(function (res) {
      _this6.concurrentOptionList = res;
    });
    this.getDictListByType('job_status').then(function (res) {
      _this6.jobStatusOptionList = res;
    });
    this.getDictListByType('job_group').then(function (res) {
      _this6.jobGroupStatusOptionList = res;
    });
  }
};